import React from 'react';
import { Section } from './Shared';
import { XCircle, CheckCircle2, Star } from 'lucide-react';
export const Transformation = () => {
  return <>
      <Section dark className="bg-black text-white" data-id="element-480">
        <div className="max-w-4xl mx-auto text-center" data-id="element-481">
          <h2 className="font-montserrat font-black text-4xl md:text-6xl uppercase leading-tight mb-16" data-id="element-482">
            De esto… <span className="text-coral" data-id="element-483">a esto</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-484">
            <div className="bg-red-950/30 border border-red-500/30 p-8 rounded-2xl" data-id="element-485">
              <h3 className="font-montserrat font-bold text-2xl text-red-400 mb-6 uppercase" data-id="element-486">
                Antes
              </h3>
              <ul className="space-y-4" data-id="element-487">
                {['Bloqueo', 'Miedo', 'Desorden', 'Inconstancia'].map((item, idx) => <li key={idx} className="flex items-center justify-center gap-3 text-xl font-medium text-gray-300" data-id="element-488">
                      <XCircle className="w-6 h-6 text-red-500" data-id="element-489" />
                      {item}
                    </li>)}
              </ul>
            </div>

            <div className="bg-green-950/30 border border-green-500/30 p-8 rounded-2xl" data-id="element-490">
              <h3 className="font-montserrat font-bold text-2xl text-green-400 mb-6 uppercase" data-id="element-491">
                Después
              </h3>
              <ul className="space-y-4" data-id="element-492">
                {['Claridad', 'Acción', 'Sistema', 'Constancia'].map((item, idx) => <li key={idx} className="flex items-center justify-center gap-3 text-xl font-medium text-white" data-id="element-493">
                      <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-494" />
                      {item}
                    </li>)}
              </ul>
            </div>
          </div>
        </div>
      </Section>

      <Section className="bg-gray-50" data-id="element-495">
        <div className="max-w-4xl mx-auto" data-id="element-496">
          <h2 className="font-montserrat font-black text-3xl md:text-5xl uppercase leading-tight text-center mb-16" data-id="element-497">
            No necesitás experiencia ni seguidores
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-498">
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-499">
              <h3 className="font-montserrat font-bold text-2xl text-gray-400 mb-6" data-id="element-500">
                No necesitás:
              </h3>
              <ul className="space-y-4" data-id="element-501">
                {['Tener miles de seguidores', 'Equipos caros', 'Saber edición avanzada'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-lg font-medium text-gray-600 line-through decoration-red-500 decoration-2" data-id="element-502">
                    <XCircle className="w-6 h-6 text-gray-400 shrink-0" data-id="element-503" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-md border-2 border-coral/20" data-id="element-504">
              <h3 className="font-montserrat font-bold text-2xl text-coral mb-6" data-id="element-505">
                Solo necesitás:
              </h3>
              <ul className="space-y-4" data-id="element-506">
                {['Un celular', 'Este sistema', 'Y empezar'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-xl font-bold text-black" data-id="element-507">
                      <CheckCircle2 className="w-6 h-6 text-coral shrink-0" data-id="element-508" />
                      {item}
                    </li>)}
              </ul>
            </div>
          </div>
        </div>
      </Section>

      <Section className="bg-white" data-id="element-509">
        <div className="max-w-5xl mx-auto" data-id="element-510">
          <h2 className="font-montserrat font-black text-3xl md:text-5xl uppercase leading-tight text-center mb-16" data-id="element-511">
            Lo que dicen quienes ya empezaron
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-512">
            {[{
            name: 'Valentina R.',
            age: 24,
            province: 'Buenos Aires',
            avatar: 'https://cdn.magicpatterns.com/uploads/k14ksc4NPvNMUKc4ohX2DW/valentina.png',
            text: 'Me daba terror la cámara. Este sistema me dio el paso a paso exacto para perder el miedo y empezar a grabar.'
          }, {
            name: 'Camila S.',
            age: 28,
            province: 'Córdoba',
            avatar: 'https://cdn.magicpatterns.com/uploads/556pqsuwntS7W5mK3kTVLK/camila.png',
            text: 'Pasé de 0 publicaciones a tener contenido constante todas las semanas. El planner es una locura.'
          }, {
            name: 'María José L.',
            age: 26,
            province: 'Mendoza',
            avatar: 'https://cdn.magicpatterns.com/uploads/ggwgUByJTvECmjMHJP4HTR/maria-jose.png',
            text: 'Tenía mil ideas pero no sabía cómo bajarlas. Ahora tengo claridad absoluta de qué publicar cada día.'
          }, {
            name: 'Sofía T.',
            age: 31,
            province: 'Rosario, Santa Fe',
            avatar: 'https://cdn.magicpatterns.com/uploads/nS4rV5jry256muauEhvHsX/sofia.png',
            text: 'Por fin estoy construyendo mi marca personal. Dejé de sobrepensar y empecé a actuar.'
          }, {
            name: 'Luciana M.',
            age: 23,
            province: 'Tucumán',
            avatar: 'https://cdn.magicpatterns.com/uploads/sKr71wDT8mExFnkYXn7Nn2/luciana.png',
            text: 'El mejor sistema. Simple, directo y sin relleno. Ya no me bloqueo cuando abro Instagram.'
          }].map((testimonial, idx) => <div key={idx} className="bg-gray-50 p-6 rounded-2xl border border-gray-100 flex flex-col justify-between" data-id="element-513">
                <div data-id="element-514">
                  <div className="flex gap-1 mb-4" data-id="element-515">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-516" />)}
                  </div>
                  <p className="font-opensans text-gray-700 italic mb-6" data-id="element-517">
                    "{testimonial.text}"
                  </p>
                </div>
                <div className="flex items-center gap-3 border-t border-gray-200 pt-4" data-id="element-518">
                  <img src={testimonial.avatar} alt={testimonial.name} className="w-10 h-10 rounded-full object-cover" data-id="element-519" />
                  <div data-id="element-520">
                    <p className="font-bold text-sm text-black" data-id="element-521">
                      {testimonial.name}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-522">
                      {testimonial.age} años, {testimonial.province}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </Section>
    </>;
};